import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { classNames } from 'uitk-react-utils';

interface MesoDisplayAdProps {
  uci: string;
  className?: string;
}

export class MesoDisplayAd extends React.Component<MesoDisplayAdProps> {
  private displayAd;

  constructor(props) {
    super(props);

    this.displayAd = React.createRef();
  }

  public render() {
    const className = classNames('ad-div', 'display-ad', {
      [this.props.className]: this.props.className
    });

    return (
      <ErrorBoundary label="meso.display.ad">
        <meso-display-ad ref={this.displayAd} uci={this.props.uci} class={className} />
      </ErrorBoundary>
    );
  }
}
